import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "action-view" }
const _hoisted_2 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ((_ctx.IsFaculty == 'Yes' || _ctx.IsIrbChair== 'Yes') 
            && _ctx.currentApplication.appStatus == 'Sponsor Under Review')
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          class: "btn btn-sm btn-success me-2",
          to: { name: _ctx.routeNameEdit, params: { id: _ctx.currentId } }
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_2, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/art/art005.svg" })
            ]),
            _createTextVNode(" Edit ")
          ]),
          _: 1
        }, 8, ["to"]))
      : _createCommentVNode("", true),
    _createVNode(_component_router_link, {
      class: "btn btn-sm btn-primary",
      to: { name: _ctx.routeName, params: { id: _ctx.currentId } }
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Next ")
      ]),
      _: 1
    }, 8, ["to"])
  ]))
}